import { Col, Row } from 'react-bootstrap'
import serviceList from "./all.json"

export default function Services({ language }) {
  return (
    <div id="services">
      <div>
        <div className='services '>
          <div className="overlay-service">
            <Row>
              {serviceList.map((service) => (
                service.category === "service"?
                <Col key={service.id} sm={12} md={12} lg={4} className="mb-3 mt-3" >
                  <div className=" box-card ">
                        <img src={service.image} className="box-img-style" alt="ed."/>
                      <div >
                        <h3 className='h3-service'>{language?service.titleEn:service.titleNl }</h3>
                        <p >{language?service.descEn:service.descNl}   </p>
                      </div>
                  </div>
                </Col>:null
              ))}
            </Row>
          </div>
        </div>
      </div>
    </div>
   
  )
}